
export class Penalidade {
  id: number;
  trabalho_id: number;
  usuario_id: number;
  desconto: number;
  motivo: string;
  updated_at: string;
}



// WEBPACK FOOTER //
// ./src/app/penalidade/penalidade.ts